// const { isTemplateMiddleOrTemplateTail } = require('typescript');

/* ------------------------------------------ Background V2 - Hải 21.09.2018 ----------------------------------------- */
(function (jQuery) {
  jQuery.gfGravity = function (element, options) {
    const defaults = {
      title: '',
      onSelected: function (value, $el) {},
    };

    this.settings = {};
    const $element = $(element);

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    const $gryffBody = $gfFrame.contents().find('body').first();

    const merId = $gfLeftSideBar.find('#md-settings').data('edittingID');
    const $targetElement = $gryffBody.find('#' + merId);

    const _this = this;
    let $gfGravity;
    let $gfGravityId;
    let _direction;

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      $element.hide();

      _this.setTemplate();

      $element.on('value-change', function () {
        const value = jQuery(this).attr('value');
        _this.setValue(value);
      });
      return false;
    };

    this.setTemplate = function () {
      const name = $element.attr('name');
      const $parent = $element.parent();
      let value = typeof $element.attr('value') === 'undefined' ? undefined : $element.attr('value');

      _direction = $element.attr('data-direction');
      let icons = 'icon-margin-left,icon-margin-right';
      let values = 'left,right';
      let tooltips = 'Stick to left,Stick to right';
      let title = 'Horizontal Orientation';
      let defaultValue = 'left';
      const id = `${_direction}-${$element.attr('name')}`;
      // if (!value) {
      //   value = $targetElement.attr(`data-${_direction}`);
      // }
      if (_direction == 'vertical') {
        icons = 'icon-margin-top,icon-margin-bottom';
        values = 'top,bottom';
        tooltips = 'Stick to top,Stick to bottom';
        title = 'Vertical Orientation';
        defaultValue = 'top';
      } else {
      }

      if (!value) {
        value = defaultValue;
      }

      const template =
        '<div class="gfGravity">' +
        '<div class="gfGHeader">' +
        `<span class="gfSGSubTitle">${title}</span>` +
        '<div class="gfSGclear"></div>' +
        '<div class="gfGTabs">' +
        `<input id="${id}" name="${id}" data-name="${id}" data-disable="false" data-value="${values}" data-columns="${icons}" data-icon="true" data-tooltips="${tooltips}" value="${value}" default_value="${defaultValue}" style="display: none;">` +
        '</div>' +
        '</div>' +
        '</div>';

      $element.after(template);
      $gfGravity = $element.next('.gfGravity');
      $gfGravityId = $gfGravity.find('#' + id);
      $gfGravityId.gfSegment({
        addHistory: false,
        onSelected: function (value, $el) {
          _this.settings.onSelected(value, $el);
          // $targetElement.attr(`data-${_direction}`, value);

          // const $input = $element.closest(".gfSGSettings").find(`input[requires^="${_direction}-gravity"]:not([name="${value}"])`);
          // $input.attr("value", "")
          //   .val("")
          //   .trigger("input-change")
          //   .trigger("history-change")
          //   ;
          // const inputField = $input.data("gfinputfield");
          // if (inputField) {
          //   inputField.setValue("");
          // }

          $element.attr('value', value).val(value).trigger('input-change').trigger('history-change');
        },
        onHistoryAdded: function () {
          // const value = $gfGravityId.attr("value");
        },
      });

      // Element
      // const merId = $gfLeftSideBar.find("#md-settings").data("edittingID");
      // const $targetElement = $gryffBody.find("#" + merId);
    };

    this.setValue = function (value) {
      $gfGravityId.data('gfsegment').setValue(value);
      // $targetElement.attr(`data-${_direction}`, value);
    };

    this.init();
  };
  jQuery.fn.gfGravity = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfgravity')) {
        const plugin = new jQuery.gfGravity(this, options);
        jQuery(this).data('gfgravity', plugin);
      }
    });
  };
})(jQuery);
